import styled from '@emotion/styled';

export const SensitiveValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  span {
    flex-grow: 1;
  }

  button {
    align-self: flex-end;
    width: 22px;
    height: 20px;
    padding: 0;
    margin-block: 0;

    svg {
      overflow: visible;
    }
  }
`;
